function sleep(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time))
}

export class Looper {
  private interval: number
  private times: number
  private readonly waitFor: number
  private count: number
  private timerID: NodeJS.Timeout | null
  private loop: () => Promise<void>
  constructor({ interval = 500, times = 6, waitFor = 0, loop = () => Promise.resolve() }) {
    this.interval = parseInt(String(interval))
    this.times = parseInt(String(times))
    this.waitFor = parseInt(String(waitFor))
    this.count = 0
    this.timerID = null
    this.loop = loop
  }

  $setInterval = (): Promise<any> => {
    const that = this
    return new Promise<void>((resolve, reject) => {
      if (that.timerID) {
        return that.stop()
      }
      const looper = () => {
        that.count = ++that.count
        if (that.count > that.times) {
          that.stop()
          return reject(new Error('time out'))
        }
        that.loop().then(() => {
          that.stop()
          return resolve()
        })
      }
      looper()
      that.timerID = setInterval(looper, that.interval)
    })
  }

  start = () => {
    if (this.waitFor > 0) {
      const that = this
      return (async function () {
        await sleep(that.waitFor)
        return that.$setInterval()
      })()
    } else {
      return this.$setInterval()
    }
  }

  stop = () => {
    clearInterval(Number(this.timerID))
  }
}
